import { Icon } from '@elipssolution/harfang';
import { mdiDrawPen } from '@mdi/js';

import signPages from './pages/pages';
import SignSettings from './settings/SignSettings';
import { ModuleType } from '../../types/module';
import { PermissionEnum } from '../../types/permission';
import { ModuleCodeEnum } from '../../types/widget';

const signModule: ModuleType = {
	code: ModuleCodeEnum.SIGN,
	icon: <Icon path={mdiDrawPen} />,
	name: 'Signature',
	route: `/${ModuleCodeEnum.SIGN}`,
	subItems: signPages,
	permissionCodes: [PermissionEnum.SIGN_ACCESS],
	settings: <SignSettings />,
	isCustomerFileBound: true,
};

export default signModule;
